import { render, staticRenderFns } from "./VolatilityControl.vue?vue&type=template&id=6537d7ae&scoped=true&"
import script from "./VolatilityControl.vue?vue&type=script&lang=js&"
export * from "./VolatilityControl.vue?vue&type=script&lang=js&"
import style0 from "./VolatilityControl.vue?vue&type=style&index=0&id=6537d7ae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6537d7ae",
  null
  
)

export default component.exports